import { projectsGetProjectsUnderSunwiseProjectFromSunpayUser } from '@sunwisesoftware/client-aftersales-js';

import * as creditFileSelectors from '../../creditFile/selectors';
import {
    FETCH_POWER_STATIONS,
    FETCH_POWER_STATIONS_FAILURE,
    FETCH_POWER_STATIONS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default (sunwiseProject) => (dispatch, getState) => {
    const companyId = creditFileSelectors.getCreditInstallerId(getState());

    if (!sunwiseProject) return;

    dispatch(actions[FETCH_POWER_STATIONS]());

    projectsGetProjectsUnderSunwiseProjectFromSunpayUser({
        path: { sunwise_project: sunwiseProject },
        query: { company_id: companyId },
    })
        .then((response) => {
            dispatch(actions[FETCH_POWER_STATIONS_SUCCESS](response?.data));
        })
        .catch((error) => {
            dispatch(
                actions[FETCH_POWER_STATIONS_FAILURE](
                    error?.response?.data?.detail,
                ),
            );
        });
};
